import styled, { css } from "styled-components";
import { ScreenPlatform } from "@store/ducks/Screen/screen.type";

interface StylesheetProps {
  platform: ScreenPlatform;
  /** Inside the CAN consumption tabs the header spacing is already handled by the shell */
  embedded?: boolean;
}

export const Container = styled.div<StylesheetProps>`
  padding-top: 85px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;
  overflow-y: scroll;
  margin-top: ${(prop) => (prop.platform === "mobile" && !prop.embedded ? "5rem" : "0")};

  /*
   * The "body .page" rule of the global stylesheet forces the padding that clears the fixed header,
   * and it wins over a plain class. Embedded in the CAN consumption tabs there is no header to
   * clear, so the rule is restated with the same two-class weight the other tabbed reports use.
   */
  ${(props) => props.embedded && css`
    &.page {
      padding-top: 0;
    }
  `}

  .water-addition-data {
    margin: 20px 0 200px 0;
    height: 100%;
  }

  .dataTable-title {
    font-size: 1.5rem;
    font-weight: 200;
    padding: 16px;
  }
`;

export const ContainerModal = styled.div`
  z-index: 2001;
`;
